import MostTrainingQty from "./mostTrainingQty";
import TeachingHours from "./teachingHours";

function TrainingDashboard() {
  return (
    <>
      <div>
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">TRAINING</a>
          </li>
          <li className="breadcrumb-item active">Dashboard</li>
        </ul>

        <h1 className="page-header">
          Training Dashboard <small></small>
        </h1>
        <hr className="mb-4" />
        <div className="row">
          <div className="col-lg-12">
            <TeachingHours />
            {/* <MostTrainingQty /> */}
          </div>
        </div>
      </div>
    </>
  );
}
export default TrainingDashboard;
